import React, { Fragment } from 'react';

import { LocalesKey } from '../../../../../../../locales/keys/localesKeysTypes';
import { ThreeDStockContentSearchInImageView } from '../../../ThreeDStockContentSearchInImage/ThreeDStockContentSearchInImageTypes';

import { Translate } from '../../../../../../../helpers/Translate';

import { aiSearchKeys, words } from '../../../../../../../locales/keys';

interface ThreeDStockContentPageInfoProps {
  totalCount?: number;
  page?: number;
  limit?: number;
  searchText?: string;
  i18nUnit?: LocalesKey;
  searchInImageView?: ThreeDStockContentSearchInImageView;
  detectedObjectsCount?: number;
}

function ThreeDStockContentPageInfo({
  limit = 0,
  page = 0,
  totalCount,
  searchText,
  i18nUnit,
  searchInImageView,
  detectedObjectsCount
}: ThreeDStockContentPageInfoProps) {
  const pageItems = limit * page;

  if (searchInImageView) {
    if (searchInImageView === 'all' && detectedObjectsCount == null) {
      return null;
    }

    return (
      <div className="text-gray-600 dark:text-gray-400 my-2 w-full xl:w-auto xl:flex-1 order-last xl:order-none whitespace-nowrap flex min-w-0 space-x-1">
        {searchInImageView === 'all' ? (
          <Translate
            id={aiSearchKeys.bestMatchesForDetectedObjects}
            count={detectedObjectsCount}
          />
        ) : (
          <Fragment>
            <span>{totalCount ?? 0}</span>
            <span className="lowercase">
              <Translate id={words.resultsFor} />
            </span>
            <span className="text-black dark:text-white font-semibold lowercase">
              <Translate id={aiSearchKeys.imageSearch} />
            </span>
          </Fragment>
        )}
      </div>
    );
  }

  if (!totalCount && !searchText) {
    return null;
  }

  return (
    <div className="text-gray-600 dark:text-gray-400 my-2 w-full xl:w-auto xl:flex-1 order-last xl:order-none whitespace-nowrap flex min-w-0 space-x-1">
      {totalCount > pageItems && (
        <Fragment>
          <span>{`1-${pageItems}`}</span>
          <span>
            <Translate id={words.of} />
          </span>
        </Fragment>
      )}

      <span>{totalCount}</span>
      {i18nUnit && (
        <span className="lowercase">
          <Translate id={i18nUnit} />
        </span>
      )}
      {searchText && (
        <span>
          <span className="lowercase">
            <Translate id={words.resultsFor} />
          </span>{' '}
          <span className="text-black dark:text-white font-semibold">
            &quot;{searchText}&quot;
          </span>
        </span>
      )}
    </div>
  );
}

export default ThreeDStockContentPageInfo;
